// project-imports
import { createRouterObject } from 'routes';
import ThemeCustomization from 'themes';
import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';
import useAuthSync from 'hooks/useAuthSync';


// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  // hook to listen storage events on another tab
  // for eg. to keep tokens in sync during login/ logout across tabs.
  useAuthSync();


  useEffect(() => {
    if (window.top !== window.self) {
      (window as any).top.location = window.self.location;
    }
  }, []);

  useEffect(() => {
    window.addEventListener('error', (e) => {
      console.error('🌐 Global error:', e.message, e.error);
    });

    window.addEventListener('unhandledrejection', (e) => {
      console.error('🌐 Unhandled Promise Rejection:', e.reason);
    });
  }, []);

  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <Notistack>
            <RouterProvider router={createRouterObject()} />
            <Snackbar />
          </Notistack>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
